import { Fragment } from 'react';
import moment from 'moment';

import {
  Table,
  TablePagination,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

// Hooks
import usePagination from '../../../hooks/usePagination';

// Styles
import { table_container_base } from '../../../static/styles';

const PropertyArchiveTable = ({ appointments }) => {
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePagination();

  return (
    <Fragment>
      <TableContainer component={Paper} sx={table_container_base}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell width="10%">Type</TableCell>
              <TableCell width="10%">Date</TableCell>
              <TableCell width="10%">Status</TableCell>
              <TableCell width="10%">Tech</TableCell>
              <TableCell width="10%">Source</TableCell>
              <TableCell width="40%">Notes</TableCell>
              <TableCell width="10%">Client</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {appointments.length ? (
              appointments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((appointment) => (
                <TableRow key={appointment.id}>
                  <TableCell scope="row">{appointment.type}</TableCell>
                  <TableCell>{moment(appointment.start_appt).format('MM/DD/YYYY')}</TableCell>
                  <TableCell>
                    {appointment.status === 'Active' && 'Active'}
                    {appointment.status === 'In Progress' && 'In Progress'}
                    {appointment.status === 'Completed' && 'Completed'}
                    {appointment.status === 'Cancelled' && 'Cancelled'}
                  </TableCell>
                  <TableCell>{appointment.tech}</TableCell>
                  <TableCell>{appointment.source}</TableCell>
                  <TableCell sx={{ maxWidth: 200, whiteSpace: 'wrap' }}>{appointment.notes}</TableCell>
                  <TableCell>{appointment.client_name}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} sx={{ textAlign: 'center' }}>
                  <strong>No Data</strong>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={appointments.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Clients per page"
      />
    </Fragment>
  );
};

export default PropertyArchiveTable;
